import { List } from 'components/order/list'
import { setModal, setOptions, setSelectedValue } from 'reducers/listReducer'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { FILTER_MANIFEST, TAB_MANIFEST, TABLE_MANIFEST } from 'configs/order/configManifest'
import { Alert } from 'avo-ui'
import Filter from 'components/commons/filter'
import { useLocation, useSearchParams } from 'react-router-dom'
import { constructOptionFilter, getAllQueryParams, getObjectName, getQueryFilter, setQueryParams } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_MANIFEST } from 'services/apiManifest'
import { RightButtonContainer } from './RightButtonContainer'

const INITIAL_FILTER = {
    start_date: null,
    end_date: null,
    shipping_aliases: [],
}

export const ManifestContainer = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const [orderCode, setOrderCode] = useState('')
    const [orderItem, setOrderItem] = useState({})
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const { selectedValue, modal, query: INITIAL_DATA } = useSelector((state) => state.listReducer)
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : { ...INITIAL_DATA, tab: 'pengemasan' }
    const [queryFilter, setQueryFilter] = useState({})
    const { fetching: getShippingMethod } = useFetch(API_MANIFEST.SHIPPING_METHODS)
    const { fetching: moveToManifest, isLoading: isLoadingBulkManifest } = useFetch(API_MANIFEST.BULK_MANIFEST)
    const { fetching: addManualAWB, isLoading: isLoadingAddManualAWB } = useFetch(API_MANIFEST.ADD_MANUAL_AWB)
    const { data: manifestList, fetching: getManifestList, isLoading: isLoadingManifest } = useFetch(API_MANIFEST.LIST)
    const { fetching: moveToDelivery, isLoading: isLoadingBulkPrintManifest } = useFetch(
        API_MANIFEST.BULK_PRINT_MANIFEST,
    )
    const {
        data: packingList,
        fetching: getPackingList,
        isLoading: isLoadingPacking,
    } = useFetch(API_MANIFEST.PACKING_LIST)
    const {
        data: withoutAWBList,
        fetching: getWithoutAWBList,
        isLoading: isLoadingWithoutAWB,
    } = useFetch(API_MANIFEST.WITHOUT_AWB)

    useEffect(() => {
        const currentQuery = { ...INITIAL_FILTER, ...query }
        const newQueryFilter = { shipping_aliases: [] }
        const initColumn = [...TABLE_MANIFEST?.column]?.slice(0, -1)
        const initTable = query?.tab === 'tanpa resi' ? TABLE_MANIFEST : { ...TABLE_MANIFEST, column: initColumn }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (key === 'shipping_aliases') {
                const valueOfQuery = item?.length ? item?.split(',') : []
                newQueryFilter[key] = valueOfQuery
                currentQuery[key] = valueOfQuery
            }
        })
        fetchList(currentQuery)
        setQueryFilter(newQueryFilter)
        dispatch(setOptions({ table: initTable }))
        dispatch(setSelectedValue({ tab: currentQuery?.tab }))
    }, [location?.search])

    useEffect(() => {
        dispatch(setOptions({ tab: TAB_MANIFEST }))
        if (modal?.filter) {
            getShippingMethod().then((response) => {
                FILTER_MANIFEST[0].list = constructOptionFilter(response?.data, 'label')
            })
        }
    }, [modal?.filter])

    useEffect(() => {
        let handler
        if (orderCode?.length > 0) {
            handler = setTimeout(() => {
                rightButtonConfirm(null, orderCode)
            }, 500)
        }

        return () => clearTimeout(handler)
    }, [orderCode])

    const setShowAlert = (message, itemModal, isError = false) => {
        dispatch(setModal(itemModal))
        return Alert({
            icon: isError ? 'error' : 'success',
            title: isError ? 'Error' : 'Success',
            message,
        })
    }

    const fetchList = (item = { ...INITIAL_FILTER, ...query, ...queryFilter }) => {
        switch (query?.tab) {
            case 'pengemasan':
                return getPackingList(item)
            case 'print surat jalan':
                return getManifestList(item)
            default:
                return getWithoutAWBList(item)
        }
    }

    const getDataList = () => {
        switch (query?.tab) {
            case 'pengemasan':
                return packingList?.data
            case 'print surat jalan':
                return manifestList?.data
            default:
                return withoutAWBList?.data
        }
    }

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) =>
            ['search', 'shipping_aliases', 'start_date', 'tab'].includes(item),
        )
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const onChangeTab = (value) => {
        onChangeQuery({ ...INITIAL_DATA, ...INITIAL_FILTER, tab: value })
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryFilter(filter)
        onChangeQuery({ ...queryFilter, page: 1 })
    }

    const onClickItemHandler = (item) => {
        setOrderItem({ order_id: item?.id, awb: null })
        dispatch(setModal({ addAWB: true }))
    }

    const rightButtonConfirm = (event, orderCodeValue) => {
        if (query?.tab === 'pengemasan') {
            const payload = {
                order_codes: orderCodeValue
                    ? [orderCodeValue]
                    : selectedValue?.selectedIds?.map((item) => item?.order_code?.replace(/^MSBB-/, '')),
            }
            moveToManifest(payload)
                .then(() => {
                    setIsResetSelectedItem(!isResetSelectedItem)
                    setOrderCode('')
                    setShowAlert('Move Order to Manifest Successfully', { confirm: false })
                    fetchList()
                })
                .catch(() => {
                    setOrderCode('')
                    setShowAlert('Failed Move Order to Manifest', { confirm: false }, true)
                })
        } else if (query?.tab === 'print surat jalan') {
            const payload = { order_ids: selectedValue?.selectedIds?.map((item) => item?.id) }
            moveToDelivery(payload)
                .then(() => {
                    setIsResetSelectedItem(!isResetSelectedItem)
                    setShowAlert('Move Order to Delivery Successfully', { printManifest: false })
                    fetchList()
                })
                .catch(() => {
                    setShowAlert('Failed Move Order to Delivery', { printManifest: false }, true)
                })
        } else {
            addManualAWB(orderItem)
                .then(() => {
                    setIsResetSelectedItem(!isResetSelectedItem)
                    setShowAlert('Add AWB & Move Order to Delivery Successfully', { addAWB: false })
                    fetchList()
                })
                .catch(() => {
                    setShowAlert('Failed Add AWB & Move Order to Delivery', { addAWB: false }, true)
                })
        }
    }

    const rightButton = () => {
        return (
            <RightButtonContainer
                totalResult={getDataList()?.total_result}
                orderCode={orderCode}
                setOrderCode={setOrderCode}
                isLoadingBulkManifest={isLoadingBulkManifest}
                isLoadingAddManualAWB={isLoadingAddManualAWB}
                isLoadingBulkPrintManifest={isLoadingBulkPrintManifest}
                setModalHandler={(item) => dispatch(setModal(item))}
                rightButtonConfirm={rightButtonConfirm}
                orderItem={orderItem}
                onChangeAWB={(value) => setOrderItem({ ...orderItem, awb: value })}
            />
        )
    }

    const filter = () => {
        return (
            <Filter
                show={modal?.filter}
                setShow={(value) => dispatch(setModal({ filter: value }))}
                options={FILTER_MANIFEST}
                values={queryFilter}
                onSubmit={(value) => onFilter(value)}
            />
        )
    }

    const props = {
        dataList: getDataList(),
        query,
        onChangeQuery,
        onChangeTab,
        isLoading: isLoadingPacking || isLoadingManifest || isLoadingWithoutAWB,
        isLoadingConfirm: isLoadingBulkManifest,
        isDateRange: true,
        rightButtonConfirm,
        rightButton,
        onClickItemHandler,
        filter,
        isShowOnSelectItem: query?.tab !== 'tanpa resi',
        isResetSelectedItem,
    }

    return <List {...props} />
}
